import $ from 'jquery'
import AccountWorkflowFilter from './../handlers/working-screen/account_workflow_filter'
import AccountStatuses from './../handlers/working-screen/account_statuses'
import ToggleAccountGroup from './../handlers/working-screen/toggle_account_group'

const setup = () => {
  if ($('[data-behaviour~="workflow-account-list"]').length === 0) {
    return
  }

  const $accountList = $('[data-behaviour~="filtered-workflow-account-list"]')

  const $filterWrapper = $(
    '[data-behaviour~="workflow-account-filter-wrapper"]'
  )

  // Order of initializers is important, AccountWorkflowFilter should be defined before AccountStatuses, because it's listening on second one events that can be triggered immediately
  new AccountWorkflowFilter($accountList, $filterWrapper)
  new AccountStatuses($accountList, $filterWrapper)
  new ToggleAccountGroup($accountList, $filterWrapper)
}

onDomLoad(() => {
  // only used in async-rendered ledger_table - only initialize this on render_async_load
  document.addEventListener('render_async_load', setup)

  document.addEventListener(
    'turbolinks:visit',
    () => {
      document.removeEventListener('render_async_load', setup)
    },
    { once: true }
  )
})
